// extracted by mini-css-extract-plugin
export default {"img-responsive":"SectionTestimonyComment_img-responsive__gxZEv","username":"SectionTestimonyComment_username__Fg3-f"};